import { useEffect, useState } from 'react'

// Track the cursor's geographic position over the map (rAF-throttled so at most
// one update per frame). Returns { lng, lat } or null when the cursor is off-map.
export function useCoordinates(map) {
  const [coords, setCoords] = useState(null)

  useEffect(() => {
    if (!map.current) return
    let raf = null
    let pending = null
    const onMove = (e) => {
      pending = e.lngLat
      if (raf) return
      raf = requestAnimationFrame(() => {
        raf = null
        if (pending) setCoords({ lng: pending.lng, lat: pending.lat })
      })
    }
    const onOut = () => setCoords(null)
    map.current.on('mousemove', onMove)
    map.current.on('mouseout', onOut)
    return () => {
      if (raf) cancelAnimationFrame(raf)
      map.current?.off('mousemove', onMove)
      map.current?.off('mouseout', onOut)
    }
  }, [map])

  return coords
}
